import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DashboardTemplate from "../../Common/DashboardTemplate";
import {
    Checkbox,
    CircularProgress, FormControl, InputLabel, MenuItem, Select,
    TablePagination, Typography, InputAdornment
} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { v4 as uuid } from 'uuid';
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import BulkAssignVehiclesDrawer from "./BulkAssignVehiclesDrawer";
import {faTrash, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import { AuthenticationService } from "../../../Services/AuthenticationService";
import { filterPersistenceService } from "../../../Services/FilterPersistenceService";
import {parseNumberInputValue} from '../../../utils/numberInputUtils';
import PartDisplay from '../../Common/PartDisplay';
import {
    getNextSortState,
    applyCatalogDisplaySort,
    usesCatalogCategoryHeaders,
    sortPartsExpandedDefault,
} from '../../../utils/tableSortUtils';
import SortableTableHeader from '../../Common/SortableTableHeader';

let editingPart;

const styles = theme => ({
    wrapper: {
        margin: -5,
    },
    filterToggle: {
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '2px 10px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        minWidth: '150px',
        '& .MuiCheckbox-root': {
            padding: '0px',
            color: '#35d2d9',
            '&.Mui-checked': {
                color: '#35d2d9',
            },
        }
    },
    filterLabel: {
        marginLeft: '8px',
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    toolbarLeft: {
        display: 'flex',
        alignItems: 'center',
    },
    toolbarRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    title: {
        fontSize: '24px',
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.87)',
    }
});

class AdminParts extends React.Component {
    state = {
        loading: true,
        user: {},
        users: [],
        parts: [],
        vendors: [],
        showAdvancedInfo: false,
        showDeactivated: false,
        showOldRevs: false,
        page: 0,
        rowsPerPage: 100,
        searchTerm: '',
        // Filter states
        selectedPartType: '',
        selectedManufacturerFor: '',
        selectedTertiaryType: '',
        selectedBrand: '',
        // Category editing states
        editPartTypeOpen: false,
        editManufacturerForOpen: false,
        editTertiaryTypeOpen: false,
        // Form values for category editing
        newPartTypeValue: '',
        newManufacturerForValue: '',
        newTertiaryTypeValue: '',
        oldValue: '',
        savingCategory: false,
        // For tracking unsaved changes in edit part form
        editingPartOriginal: null,
        // Multiselect functionality
        selectedParts: {},
        lastSelectedIndex: null, // Track last clicked index for Shift+Click range selection
        isProcessingModifierClick: false, // Flag to prevent checkbox onChange during modifier clicks
        assignCategoryOpen: false,
        assignVehiclesOpen: false,
        // Primary category
        primaryCategoryValue: '',
        primaryCategoryNewValue: '',
        showNewPrimaryCategoryField: false,
        // Secondary category
        secondaryCategoryValue: '',
        secondaryCategoryNewValue: '',
        showNewSecondaryCategoryField: false,
        // Tertiary category
        tertiaryCategoryValue: '',
        tertiaryCategoryNewValue: '',
        showNewTertiaryCategoryField: false,
        // Brand
        brandValue: '',
        brandNewValue: '',
        showNewBrandField: false,
        // Input values for autocomplete
        primaryCategoryInputValue: '',
        secondaryCategoryInputValue: '',
        tertiaryCategoryInputValue: '',
        brandInputValue: '',
        // Data arrays
        vendorParts: [],
        bulkLeadTimeDrawerOpen: false,
        bulkLeadTimeWeeks: '',
        bulkLeadTimeTargetParts: [],
        bulkLeadTimeConfirmText: '',
        savingBulkLeadTime: false,
        sortField: null,
        sortDirection: 'asc',
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage}, () => {
            this.saveFilterSettings();
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleSort = (field) => {
        this.setState((prevState) => {
            const next = getNextSortState(prevState.sortField, prevState.sortDirection, field);
            return {
                sortField: next.field,
                sortDirection: next.direction,
                page: 0,
            };
        }, () => {
            this.saveFilterSettings();
        });
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadSavedFilterSettings();
        this.loadData();
    }

    loadSavedFilterSettings = () => {
        const savedSettings = filterPersistenceService.loadFilterSettings('parts');
        if (savedSettings) {
            this.setState({
                page: savedSettings.page || 0,
                rowsPerPage: savedSettings.rowsPerPage || 100,
                searchTerm: savedSettings.searchTerm || '',
                selectedPartType: savedSettings.selectedPartType || '',
                selectedManufacturerFor: savedSettings.selectedManufacturerFor || '',
                selectedTertiaryType: savedSettings.selectedTertiaryType || '',
                selectedBrand: savedSettings.selectedBrand || '',
                showAdvancedInfo: savedSettings.showAdvancedInfo || false,
                showDeactivated: savedSettings.showDeactivated || false,
                showOldRevs: savedSettings.showOldRevs || false
            });
        }
    }

    saveFilterSettings = () => {
        const settings = {
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            searchTerm: this.state.searchTerm,
            selectedPartType: this.state.selectedPartType,
            selectedManufacturerFor: this.state.selectedManufacturerFor,
            selectedTertiaryType: this.state.selectedTertiaryType,
            selectedBrand: this.state.selectedBrand,
            showAdvancedInfo: this.state.showAdvancedInfo,
            showDeactivated: this.state.showDeactivated,
            showOldRevs: this.state.showOldRevs
        };
        filterPersistenceService.saveFilterSettings('parts', settings);
    }

    loadData = () => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Workshop')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        Promise.all([self.loadParts(), self.loadVendors()]).then(() => {
            self.setState({loading: false, user, permissions: user.userPermissions});
            // Focus search bar after render
            setTimeout(() => {
                if (this.searchInputRef) {
                    this.searchInputRef.focus();
                }
            }, 100);
        });
    };

    loadVendors = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllVendors().then((vendors) => {
            this.setState({vendors});
        })
    };

    loadParts = () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((partsResult) => {
            const allParts = sortPartsExpandedDefault(partsResult);
            allParts.forEach((part) => {part.desiredWeeksAhead = part.part.leadTimeInWeeks});
            self.setState({parts: allParts});
        });
    };

    toggleAdvancedInfo = () => {
        const {showAdvancedInfo} = this.state;
        this.setState({showAdvancedInfo: !showAdvancedInfo}, () => {
            this.saveFilterSettings();
        });
    };

    toggleDeactivated = () => {
        const {showDeactivated} = this.state;
        this.setState({showDeactivated: !showDeactivated}, () => {
            this.saveFilterSettings();
        });
    };

    toggleOldRevs = () => {
        const {showOldRevs} = this.state;
        this.setState({showOldRevs: !showOldRevs}, () => {
            this.saveFilterSettings();
        });
    };

    searchPart = (event) => {
        const searchTerm = event.target.value;
        this.setState({searchTerm: searchTerm, page: 0}, () => {
            this.saveFilterSettings();
        });
    };

    handleRowClick = (e, part) => {
        const self = this;
        if (!self.state.permissions.includes('EditAssembliesAndParts')) return;
        switch (e.detail) {
            case 2:
                self.editPart(part, e.ctrlKey);
                break;
            default:
                break;
        }
    };

    editPart = (partExpanded, newTab) => {
        if (newTab)
            window.open(`/admin/parts/${partExpanded.part.id}`);
        else
            globalProps.history.push(`/admin/parts/${partExpanded.part.id}`);
    };

    handleInventoryStrategyChange = (strategy) => {
        editingPart.part.inventoryStrategy = strategy;
        this.setState({editingPart});
    };

    changePartTypeSelection = (event, newValue) => {
        if (!newValue || newValue === 'New...') {
            editingPart.part.partType = !newValue ? '' : newValue;
            this.setState({editingPart, newPartType: true});
        } else {
            editingPart.part.partType = newValue;
            this.setState({editingPart, newPartType: false});
        }
    };

    changePartType = (event) => {
        editingPart.part.partType = event.target.value;
        this.setState({editingPart});
    };

    changeManufacturerForSelection = (event, newValue) => {
        if (!newValue || newValue === 'New...') {
            editingPart.part.manufacturerFor = !newValue ? '' : newValue;
            this.setState({editingPart, newManufacturerFor: true});
        } else {
            editingPart.part.manufacturerFor = newValue;
            this.setState({editingPart, newManufacturerFor: false});
        }
    };

    changeManufacturerFor = (event) => {
        editingPart.part.manufacturerFor = event.target.value;
        this.setState({editingPart});
    };

    changeTertiaryTypeSelection = (event, newValue) => {
        if (!newValue || newValue === 'New...') {
            editingPart.part.tertiaryType = !newValue ? '' : newValue;
            this.setState({editingPart, newTertiaryType: true});
        } else {
            editingPart.part.tertiaryType = newValue;
            this.setState({editingPart, newTertiaryType: false});
        }
    };

    changeTertiaryType = (event) => {
        editingPart.part.tertiaryType = event.target.value;
        this.setState({editingPart});
    };

    changePartId = (event) => {
        editingPart.part.partId = event.target.value;
        this.setState({editingPart});
    };

    changeRevision = (event) => {
        editingPart.part.revision = event.target.value;
        this.setState({editingPart});
    };

    changeRevisionNotes = (event) => {
        editingPart.part.revisionNotes = event.target.value;
        this.setState({editingPart});
    };

    changeDescription = (event) => {
        editingPart.part.description = event.target.value;
        this.setState({editingPart});
    };

    changeMSRP = (event) => {
        editingPart.part.msrp = event.target.value;
        this.setState({editingPart});
    };

    changeLeadTime = (event) => {
        editingPart.part.leadTimeInWeeks = event.target.value;
        this.setState({editingPart});
    };

    handleCloseEditPart = () => {
        this.setState({editingPart: null, editingPartOriginal: null, editPartOpen: false});
    };

    savePart = () => {
        const self = this;
        self.setState({savingPart: true});
        const partService = ServiceLocator.Instance.getPartService();
        if (this.state.parts.find(x => x.part.partId.toLowerCase().trim() === editingPart.part.partId.toLowerCase().trim() && x.part.revision.toLowerCase().trim() === editingPart.part.revision.toLowerCase().trim())) {
            self.setState({savingPart: false});
            return window.$alertWarning("A part already exists with that Part Number and Revision!");
        } else {
            // Ensure fileURLs is a string (not an array)
            let fileURLsString = '';
            if (editingPart.part.fileURLs) {
                if (typeof editingPart.part.fileURLs === 'string') {
                    fileURLsString = editingPart.part.fileURLs;
                } else if (Array.isArray(editingPart.part.fileURLs)) {
                    fileURLsString = editingPart.part.fileURLs.filter(x => x && x.trim() !== '').join('~|~');
                }
            }
            
            // Create a clean part object without navigation properties
            const cleanPart = {
                id: editingPart.part.id,
                partType: editingPart.part.partType,
                manufacturerFor: editingPart.part.manufacturerFor,
                tertiaryType: editingPart.part.tertiaryType || '',
                partId: editingPart.part.partId,
                revision: editingPart.part.revision,
                revisionNotes: editingPart.part.revisionNotes || '',
                description: editingPart.part.description,
                imageURL: '',
                fileURLs: fileURLsString, // Ensure it's a string
                costType: editingPart.part.costType || 0,
                isActive: editingPart.part.isActive,
                isSmallBinSize: editingPart.part.isSmallBinSize || false,
                basePrice: editingPart.part.basePrice || 0,
                quantity: editingPart.part.quantity || 0,
                minimumQuantity: (editingPart.part.minimumQuantity === '' || editingPart.part.minimumQuantity === null || editingPart.part.minimumQuantity === undefined)
                    ? 2
                    : parseNumberInputValue(editingPart.part.minimumQuantity),
                reorderByMinimumQuantity: !!editingPart.part.reorderByMinimumQuantity,
                msrp: parseNumberInputValue(editingPart.part.msrp) || 0,
                msrpUseMarginPricing: !!editingPart.part.msrpUseMarginPricing,
                msrpMarginPercent: parseNumberInputValue(editingPart.part.msrpMarginPercent),
                msrpRoundThreshold: parseNumberInputValue(editingPart.part.msrpRoundThreshold) || 15,
                msrpRoundBelowIncrement: parseNumberInputValue(editingPart.part.msrpRoundBelowIncrement) || 0.25,
                msrpRoundAtOrAboveIncrement: parseNumberInputValue(editingPart.part.msrpRoundAtOrAboveIncrement) || 1,
                leadTimeInWeeks: parseNumberInputValue(editingPart.part.leadTimeInWeeks) || 2,
                inventoryStrategy: editingPart.part.inventoryStrategy || 'A',
                inventoryCorrection: editingPart.part.inventoryCorrection || 0,
                supersededById: editingPart.part.supersededById || null,
                supersedesId: editingPart.part.supersedesId || null,
                effectiveDate: editingPart.part.effectiveDate || null,
                currentlyPurchasing: editingPart.part.currentlyPurchasing || false,
                selectedVendorId: editingPart.part.selectedVendorId || null
            };
            
            partService.createPart(cleanPart).then((part) => {
                window.$alertSuccess("Part created");
                self.setState({editPartOpen: false, savingPart: false});
                globalProps.history.push('/admin/parts/' + part.id);
            });
        }
    };

    createPart = () => {
        editingPart = {
            part: {
                id: uuid(),
                partType: '',
                manufacturerFor: '',
                partId: '',
                revision: '',
                revisionNotes: '',
                description: '',
                weightPounds: 0,
                weightOunces: 0,
                msrp: 0,
                msrpUseMarginPricing: false,
                msrpMarginPercent: 0,
                msrpRoundThreshold: 15,
                msrpRoundBelowIncrement: 0.25,
                msrpRoundAtOrAboveIncrement: 1,
                leadTimeInWeeks: 2,
                minimumQuantity: 2,
                reorderByMinimumQuantity: false,
                inventoryStrategy: 'A',
                isActive: true,
                vendorParts: []
            }
        };
        this.setState({
            editingPart: editingPart, 
            editingPartOriginal: JSON.parse(JSON.stringify(editingPart)), // Deep copy for comparison
            editPartOpen: true, 
            newPartType: false, 
            newManufacturerFor: false
        });
    };

    // Filter handler methods
    handlePartTypeFilterChange = (event, newValue) => {
        this.setState({
            selectedPartType: newValue || '',
            selectedManufacturerFor: '', // Reset dependent filters
            selectedTertiaryType: '',
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleManufacturerForFilterChange = (event, newValue) => {
        this.setState({
            selectedManufacturerFor: newValue || '',
            selectedTertiaryType: '', // Reset dependent filter
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleTertiaryTypeFilterChange = (event, newValue) => {
        this.setState({
            selectedTertiaryType: newValue || '',
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleBrandFilterChange = (event, newValue) => {
        this.setState({
            selectedBrand: newValue || '',
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    // Category editing methods
    savePartType = async () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();
        
        self.setState({ savingCategory: true });
        
        try {
            await partService.updatePartType(self.state.newPartTypeValue, self.state.oldValue);
            
            // Double reload for cache clearing
            await self.loadData();
            setTimeout(async () => {
                await self.loadData();
                self.setState({
                    editPartTypeOpen: false,
                    newPartTypeValue: '',
                    oldValue: '',
                    savingCategory: false
                });
            }, 500);
        } catch (error) {
            console.error('Error saving category:', error);
            self.setState({ savingCategory: false });
        }
    };

    saveManufacturerFor = async () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();
        
        self.setState({ savingCategory: true });
        
        try {
            await partService.updateManufacturerFor(self.state.newManufacturerForValue, self.state.oldValue);
            
            // Double reload for cache clearing
            await self.loadData();
            setTimeout(async () => {
                await self.loadData();
                self.setState({
                    editManufacturerForOpen: false,
                    newManufacturerForValue: '',
                    oldValue: '',
                    savingCategory: false
                });
            }, 500);
        } catch (error) {
            console.error('Error saving category:', error);
            self.setState({ savingCategory: false });
        }
    };

    saveTertiaryType = async () => {
        const self = this;
        const partService = ServiceLocator.Instance.getPartService();
        
        self.setState({ savingCategory: true });
        
        try {
            await partService.updateTertiaryCategory(self.state.newTertiaryTypeValue, self.state.oldValue);
            
            // Double reload for cache clearing
            await self.loadData();
            setTimeout(async () => {
                await self.loadData();
                self.setState({
                    editTertiaryTypeOpen: false,
                    newTertiaryTypeValue: '',
                    oldValue: '',
                    savingCategory: false
                });
            }, 500);
        } catch (error) {
            console.error('Error saving category:', error);
            self.setState({ savingCategory: false });
        }
    };

    // Header click handlers for editing categories
    handlePartTypeHeaderClick = (partType) => {
        if (this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts')) {
            this.setState({
                editPartTypeOpen: true,
                newPartTypeValue: partType,
                oldValue: partType
            });
        }
    };

    handleManufacturerForHeaderClick = (manufacturerFor) => {
        if (this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts')) {
            this.setState({
                editManufacturerForOpen: true,
                newManufacturerForValue: manufacturerFor,
                oldValue: manufacturerFor
            });
        }
    };

    handleTertiaryTypeHeaderClick = (tertiaryType) => {
        if (this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts')) {
            this.setState({
                editTertiaryTypeOpen: true,
                newTertiaryTypeValue: tertiaryType,
                oldValue: tertiaryType
            });
        }
    };

    // Multiselect functionality
    handlePartSelection = (partId, event) => {
        // Get filtered parts array for range selection
        let filteredParts = this.state.parts.filter(x => x.part.isActive === true || this.state.showDeactivated);
        
        if (this.state.selectedPartType) {
            filteredParts = filteredParts.filter(x => x.part.partType === this.state.selectedPartType);
        }
        if (this.state.selectedManufacturerFor) {
            filteredParts = filteredParts.filter(x => x.part.manufacturerFor === this.state.selectedManufacturerFor);
        }
        if (this.state.selectedTertiaryType) {
            filteredParts = filteredParts.filter(x => x.part.tertiaryType === this.state.selectedTertiaryType);
        }
        if (this.state.selectedBrand) {
            filteredParts = filteredParts.filter(x => x.part.brand === this.state.selectedBrand);
        }

        // Filter out old revisions if showOldRevs is false
        if (!this.state.showOldRevs) {
            const latestRevisionMap = new Map();
            filteredParts.forEach(part => {
                const partId = part.part.partId;
                if (!latestRevisionMap.has(partId) || parseInt(part.part.revision) > parseInt(latestRevisionMap.get(partId).part.revision)) {
                    latestRevisionMap.set(partId, part);
                }
            });
            filteredParts = Array.from(latestRevisionMap.values());
        }

        // Apply search filter
        if (this.state.searchTerm) {
            const searchTerms = this.state.searchTerm.split(' ').filter(term => term.trim() !== '');
            if (searchTerms.length > 0) {
                filteredParts = filteredParts.filter(part => {
                    return searchTerms.every(term => {
                        const searchTerm = term.toLowerCase();
                        return (
                            (part.part.partId && part.part.partId.toLowerCase().includes(searchTerm)) ||
                            (part.part.description && part.part.description.toLowerCase().includes(searchTerm)) ||
                            (part.part.partType && part.part.partType.toLowerCase().includes(searchTerm)) ||
                            (part.part.manufacturerFor && part.part.manufacturerFor.toLowerCase().includes(searchTerm)) ||
                            (part.part.brand && part.part.brand.toLowerCase().includes(searchTerm))
                        );
                    });
                });
            }
        }

        const currentIndex = filteredParts.findIndex(p => p.part.id === partId);
        const isCurrentlySelected = !!this.state.selectedParts[partId];
        
        // Check for modifier keys
        const isCtrlPressed = (event && (event.ctrlKey || event.metaKey)) || 
                             (event.nativeEvent && (event.nativeEvent.ctrlKey || event.nativeEvent.metaKey));
        const isShiftPressed = (event && event.shiftKey) || 
                               (event.nativeEvent && event.nativeEvent.shiftKey);
        
        // Set flag to prevent checkbox onChange from processing modifier clicks
        const hasModifiers = isCtrlPressed || isShiftPressed;
        if (hasModifiers) {
            this.setState({ isProcessingModifierClick: true });
            if (event && event.preventDefault) event.preventDefault();
            if (event && event.stopPropagation) event.stopPropagation();
        }
        
        if (currentIndex === -1) {
            // Part not found in filtered data, fall back to simple toggle
            const selectedParts = { ...this.state.selectedParts };
            if (isCurrentlySelected) {
                delete selectedParts[partId];
            } else {
                selectedParts[partId] = true;
            }
            this.setState({ 
                selectedParts,
                lastSelectedIndex: null
            });
            if (hasModifiers) {
                setTimeout(() => {
                    this.setState({ isProcessingModifierClick: false });
                }, 100);
            }
            return;
        }

        if (isShiftPressed && this.state.lastSelectedIndex !== null && this.state.lastSelectedIndex !== -1) {
            // Shift+Click: Select range from lastSelectedIndex to currentIndex
            const startIndex = Math.min(this.state.lastSelectedIndex, currentIndex);
            const endIndex = Math.max(this.state.lastSelectedIndex, currentIndex);
            const rangeIds = filteredParts.slice(startIndex, endIndex + 1).map(p => p.part.id);
            
            if (isCtrlPressed) {
                // Ctrl+Shift+Click: Toggle range selection
                const allInRangeSelected = rangeIds.every(id => !!this.state.selectedParts[id]);
                const selectedParts = { ...this.state.selectedParts };
                if (allInRangeSelected) {
                    // Remove all items in range
                    rangeIds.forEach(id => delete selectedParts[id]);
                } else {
                    // Add all items in range
                    rangeIds.forEach(id => selectedParts[id] = true);
                }
                this.setState({
                    selectedParts,
                    lastSelectedIndex: currentIndex
                });
            } else {
                // Shift+Click: Add range, or remove range when anchor/range indicates deselection flow
                const selectedParts = { ...this.state.selectedParts };
                const anchorId = filteredParts[this.state.lastSelectedIndex]?.part?.id;
                const anchorIsSelected = anchorId ? !!this.state.selectedParts[anchorId] : true;
                const allInRangeSelected = rangeIds.every(id => !!this.state.selectedParts[id]);
                const shouldDeselectRange = !anchorIsSelected || (isCurrentlySelected && allInRangeSelected);

                if (shouldDeselectRange) {
                    rangeIds.forEach(id => delete selectedParts[id]);
                } else {
                    rangeIds.forEach(id => selectedParts[id] = true);
                }

                this.setState({
                    selectedParts,
                    lastSelectedIndex: currentIndex
                });
            }
        } else if (isCtrlPressed) {
            // Ctrl+Click: Toggle individual item
            const selectedParts = { ...this.state.selectedParts };
            if (isCurrentlySelected) {
                delete selectedParts[partId];
            } else {
                selectedParts[partId] = true;
            }
            this.setState({
                selectedParts,
                lastSelectedIndex: currentIndex
            });
        } else {
            // Normal click: Simple toggle
            const selectedParts = { ...this.state.selectedParts };
            if (isCurrentlySelected) {
                delete selectedParts[partId];
            } else {
                selectedParts[partId] = true;
            }
            this.setState({
                selectedParts,
                lastSelectedIndex: currentIndex
            });
        }
        
        // Clear the modifier flag after a short delay
        if (hasModifiers) {
            setTimeout(() => {
                this.setState({ isProcessingModifierClick: false });
            }, 100);
        }
    };

    deselectAllParts = () => {
        this.setState({ selectedParts: {} });
    };

    makeNonInventoryItems = async () => {
        const partService = ServiceLocator.Instance.getPartService();
        const selectedPartIds = Object.keys(this.state.selectedParts);
        if (selectedPartIds.length === 0) return;

        // Check if all selected parts are already non-inventory items
        const selectedParts = selectedPartIds.map(partId => 
            this.state.parts.find(p => p.part.id === partId)
        ).filter(Boolean);
        
        const allNonInventory = selectedParts.every(part => !part.part.isInventoryItem);
        const newInventoryStatus = allNonInventory; // true = make inventory items, false = make non-inventory items
        
        const actionText = allNonInventory ? 'inventory items' : 'non-inventory items';
        const confirmMessage = `Are you sure you want to make ${selectedPartIds.length} selected part(s) ${actionText}?`;
        if (!window.confirm(confirmMessage)) return;

        try {
            const updatePromises = selectedPartIds.map(async (partId) => {
                const partExpanded = this.state.parts.find(p => p.part.id === partId);
                if (!partExpanded) {
                    console.error(`Part with ID ${partId} not found`);
                    return;
                }

                // Ensure fileURLs is a string (not an array)
                let fileURLsString = '';
                if (partExpanded.part.fileURLs) {
                    if (typeof partExpanded.part.fileURLs === 'string') {
                        fileURLsString = partExpanded.part.fileURLs;
                    } else if (Array.isArray(partExpanded.part.fileURLs)) {
                        fileURLsString = partExpanded.part.fileURLs.filter(x => x && x.trim() !== '').join('~|~');
                    }
                }
                
                const partToUpdate = {
                    ...partExpanded.part,
                    isInventoryItem: newInventoryStatus,
                    fileURLs: fileURLsString // Ensure it's a string
                };

                return partService.updatePart(partToUpdate);
            });

            await Promise.all(updatePromises);
            
            // Refresh the parts data
            await this.loadParts();
            
            // Clear selection
            this.setState({ selectedParts: {} });
            
            window.$alertSuccess(`${selectedPartIds.length} part(s) have been made ${actionText}.`);
        } catch (error) {
            console.error('Error updating parts inventory status:', error);
            window.$alertError('Failed to update parts inventory status. Please try again.');
        } finally {
            this.setState({ loading: false });
        }
    };

    getNormalizedFileUrls = (fileURLs) => {
        if (!fileURLs) return '';
        if (typeof fileURLs === 'string') return fileURLs;
        if (Array.isArray(fileURLs)) return fileURLs.filter(x => x && x.trim() !== '').join('~|~');
        return '';
    };

    getVendorNameById = (vendorId) => {
        if (!vendorId) return '';
        const vendor = (this.state.vendors || []).find(v => String(v.id) === String(vendorId));
        return vendor?.name || '';
    };

    openBulkLeadTimeForSelected = () => {
        const selectedPartIds = Object.keys(this.state.selectedParts);
        if (selectedPartIds.length === 0) {
            window.$alertError('Select at least one part first.');
            return;
        }

        const selectedTargetParts = selectedPartIds
            .map(id => this.state.parts.find(p => p.part.id === id))
            .filter(Boolean);

        this.setState({
            bulkLeadTimeDrawerOpen: true,
            bulkLeadTimeWeeks: '',
            bulkLeadTimeConfirmText: '',
            bulkLeadTimeTargetParts: selectedTargetParts
        });
    };

    closeBulkLeadTimeDrawer = () => {
        this.setState({
            bulkLeadTimeDrawerOpen: false,
            bulkLeadTimeWeeks: '',
            bulkLeadTimeConfirmText: '',
            bulkLeadTimeTargetParts: [],
            savingBulkLeadTime: false
        });
    };

    applyBulkLeadTimeUpdate = async () => {
        const leadTimeWeeks = parseNumberInputValue(this.state.bulkLeadTimeWeeks);
        if (!Number.isFinite(leadTimeWeeks) || leadTimeWeeks <= 0) {
            window.$alertError('Enter a valid lead time in weeks.');
            return;
        }

        const targetParts = this.state.bulkLeadTimeTargetParts || [];
        if (targetParts.length === 0) {
            window.$alertError('No parts match this update request.');
            return;
        }

        if ((this.state.bulkLeadTimeConfirmText || '').trim().toUpperCase() !== 'UPDATE') {
            window.$alertError('Type UPDATE to confirm this bulk lead time change.');
            return;
        }

        this.setState({ savingBulkLeadTime: true });

        try {
            const partService = ServiceLocator.Instance.getPartService();
            await Promise.all(targetParts.map((partExpanded) => {
                const updatedPart = {
                    ...partExpanded.part,
                    leadTimeInWeeks: leadTimeWeeks,
                    fileURLs: this.getNormalizedFileUrls(partExpanded.part.fileURLs)
                };
                return partService.updatePart(updatedPart);
            }));

            await this.loadParts();
            this.setState({
                selectedParts: {},
                bulkLeadTimeDrawerOpen: false,
                bulkLeadTimeWeeks: '',
                bulkLeadTimeConfirmText: '',
                bulkLeadTimeTargetParts: [],
                savingBulkLeadTime: false
            });

            window.$alertSuccess(`Updated lead time to ${leadTimeWeeks} week(s) for ${targetParts.length} part(s).`);
        } catch (error) {
            console.error('Error updating lead times in bulk:', error);
            window.$alertError('Failed to update lead times.');
            this.setState({ savingBulkLeadTime: false });
        }
    };

    openAssignCategory = () => {
        this.setState({
            assignCategoryOpen: true,
            primaryCategoryValue: '',
            primaryCategoryNewValue: '',
            showNewPrimaryCategoryField: false,
            secondaryCategoryValue: '',
            secondaryCategoryNewValue: '',
            showNewSecondaryCategoryField: false,
            tertiaryCategoryValue: '',
            tertiaryCategoryNewValue: '',
            showNewTertiaryCategoryField: false,
            brandValue: '',
            brandNewValue: '',
            showNewBrandField: false
        });
    };

    closeAssignCategory = () => {
        this.setState({
            assignCategoryOpen: false,
            primaryCategoryValue: '',
            primaryCategoryInputValue: '',
            primaryCategoryNewValue: '',
            showNewPrimaryCategoryField: false,
            secondaryCategoryValue: '',
            secondaryCategoryInputValue: '',
            secondaryCategoryNewValue: '',
            showNewSecondaryCategoryField: false,
            tertiaryCategoryValue: '',
            tertiaryCategoryInputValue: '',
            tertiaryCategoryNewValue: '',
            showNewTertiaryCategoryField: false,
            brandValue: '',
            brandInputValue: '',
            brandNewValue: '',
            showNewBrandField: false
        });
    };

    hasEditPartUnsavedChanges = () => {
        if (!this.state.editingPart || !this.state.editingPartOriginal) return false;
        
        const current = this.state.editingPart.part;
        const original = this.state.editingPartOriginal.part;
        
        return (
            current.partType !== original.partType ||
            current.manufacturerFor !== original.manufacturerFor ||
            current.partId !== original.partId ||
            current.revision !== original.revision ||
            current.revisionNotes !== original.revisionNotes ||
            current.description !== original.description ||
            current.msrp !== original.msrp ||
            current.leadTimeInWeeks !== original.leadTimeInWeeks ||
            current.inventoryStrategy !== original.inventoryStrategy ||
            this.state.newPartType !== '' ||
            this.state.newManufacturerFor !== ''
        );
    };

    getTieredPricingTooltip = (partTieredCostFormulas) => {
        if (!partTieredCostFormulas || partTieredCostFormulas.length === 0) {
            return 'No tiered pricing available';
        }
        
        return partTieredCostFormulas
            .sort((a, b) => a.quantity - b.quantity)
            .map(tier => `${tier.quantity}: $${Number(tier.price).toFixed(2)} ea`)
            .join('\n');
    };

    // Calculate unit cost for a part - matches backend SQL VendorPricing CTE exactly
    // Backend SQL (lines 171-194): Uses SelectedVendorId -> VendorParts -> TieredCostFormulas or Fixed pricing
    // Matches backend SQL VendorPricing CTE exactly
    calculateUnitCost = (partExpanded, quantityOnHand) => {
        const part = partExpanded.part;

        // Get the selected vendor part (matches backend: LEFT JOIN VendorParts ON SelectedVendorId)
        let selectedVendor = null;
        if (part.selectedVendorId !== null) {
            selectedVendor = part.vendorParts.find(x => x.vendorId === part.selectedVendorId);
        }
        // Fallback to first vendor part if no selected vendor
        if (!selectedVendor && part.vendorParts.length > 0) {
            selectedVendor = part.vendorParts[0];
        }

        // Use part.costType to match backend SQL (line 175: WHEN p.CostType = 0)
        // Backend SQL uses p.CostType from Parts table, not vendor part cost type
        const costType = part.costType ?? 0;

        // Match backend SQL logic exactly (lines 174-190)
        if (costType === 0 && selectedVendor) {
            // Tiered pricing: Get selected tiered cost formula (IsSelected = 1, ORDER BY Quantity DESC)
            // SQL: COALESCE((SELECT TOP 1 tcf.Price WHERE IsSelected = 1 ORDER BY Quantity DESC), vp.BasePrice)
            if (selectedVendor.tieredCostFormulas && selectedVendor.tieredCostFormulas.length > 0) {
                // Find selected formula (IsSelected = 1), sorted by Quantity DESC, take first
                const selectedFormulas = selectedVendor.tieredCostFormulas
                    .filter(f => f.isSelected)
                    .sort((a, b) => b.quantity - a.quantity);
                if (selectedFormulas.length > 0) {
                    return Number(selectedFormulas[0].price);
                }
                // If no selected formula, use basePrice (COALESCE fallback)
                return selectedVendor.basePrice || 0;
            }
            // No tiered formulas, use basePrice
            return selectedVendor.basePrice || 0;
        } else if (costType === 1 && selectedVendor) {
            // Fixed pricing: BasePrice / Quantity (if Quantity > 0), else BasePrice
            if (selectedVendor.quantity && selectedVendor.quantity > 0) {
                return Number(selectedVendor.basePrice) / Number(selectedVendor.quantity);
            }
            return selectedVendor.basePrice || 0;
        } else if (selectedVendor) {
            // Default: use basePrice
            return selectedVendor.basePrice || 0;
        } else {
            // No vendor part, use part basePrice (matches backend SQL exactly: COALESCE(vp.UnitCost, p.BasePrice))
            // SQL always uses p.BasePrice as fallback, even if 0
            return part.basePrice || 0;
        }
    };

    getCategoryOptions = (categoryType) => {
        let partTypeOptions = [];
        let manufacturerForOptions = [];
        let tertiaryTypeOptions = [];
        let brandOptions = [];
        
        this.state.parts.filter(x => x.part.isActive).forEach((part) => {
            if (part.part.partType != null && part.part.partType !== '' && !partTypeOptions.includes(part.part.partType))
                partTypeOptions.push(part.part.partType);
            if (part.part.manufacturerFor != null && part.part.manufacturerFor !== '' && !manufacturerForOptions.includes(part.part.manufacturerFor))
                manufacturerForOptions.push(part.part.manufacturerFor);
            if (part.part.tertiaryType != null && part.part.tertiaryType !== '' && !tertiaryTypeOptions.includes(part.part.tertiaryType))
                tertiaryTypeOptions.push(part.part.tertiaryType);
            if (part.part.brand != null && part.part.brand !== '' && !brandOptions.includes(part.part.brand))
                brandOptions.push(part.part.brand);
        });
        
        partTypeOptions = partTypeOptions.sort();
        manufacturerForOptions = manufacturerForOptions.sort();
        tertiaryTypeOptions = tertiaryTypeOptions.sort();
        brandOptions = brandOptions.sort();

        switch (categoryType) {
            case 'primary':
                return ['New...'].concat(partTypeOptions);
            case 'secondary':
                return ['New...'].concat(manufacturerForOptions);
            case 'tertiary':
                return ['New...'].concat(tertiaryTypeOptions);
            case 'brand':
                return ['New...'].concat(brandOptions);
            default:
                return ['New...'];
        }
    };

    saveAssignCategory = async () => {
        const selectedPartIds = Object.keys(this.state.selectedParts);
        if (selectedPartIds.length === 0) return;

        // Get the final values for each category
        const primaryValue = this.state.showNewPrimaryCategoryField ? this.state.primaryCategoryNewValue : this.state.primaryCategoryValue;
        const secondaryValue = this.state.showNewSecondaryCategoryField ? this.state.secondaryCategoryNewValue : this.state.secondaryCategoryValue;
        const tertiaryValue = this.state.showNewTertiaryCategoryField ? this.state.tertiaryCategoryNewValue : this.state.tertiaryCategoryValue;
        const brandValue = this.state.showNewBrandField ? this.state.brandNewValue : this.state.brandValue;

        // Check if at least one category is specified
        if (!primaryValue && !secondaryValue && !tertiaryValue && !brandValue) {
            window.$alertError('Please specify at least one category or brand');
            return;
        }

        this.setState({ savingCategory: true });

        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Update each selected part with the new categories
            for (const partId of selectedPartIds) {
                const partExpanded = this.state.parts.find(p => p.part.id === partId);
                if (partExpanded) {
                    // Ensure fileURLs is a string (not an array)
                    let fileURLsString = '';
                    if (partExpanded.part.fileURLs) {
                        if (typeof partExpanded.part.fileURLs === 'string') {
                            fileURLsString = partExpanded.part.fileURLs;
                        } else if (Array.isArray(partExpanded.part.fileURLs)) {
                            fileURLsString = partExpanded.part.fileURLs.filter(x => x && x.trim() !== '').join('~|~');
                        }
                    }
                    
                    const updatedPart = { 
                        ...partExpanded.part,
                        fileURLs: fileURLsString // Ensure it's a string
                    };
                    
                    // Update categories only if they were specified
                    if (primaryValue) {
                        updatedPart.partType = primaryValue;
                    }
                    if (secondaryValue) {
                        updatedPart.manufacturerFor = secondaryValue;
                    }
                    if (tertiaryValue) {
                        updatedPart.tertiaryType = tertiaryValue;
                    }
                    if (brandValue) {
                        updatedPart.brand = brandValue;
                    }
                    
                    await partService.updatePart(updatedPart);
                }
            }

            // Reload data and close drawer
            await this.loadData();
            this.setState({ 
                selectedParts: {},
                assignCategoryOpen: false,
                savingCategory: false,
                primaryCategoryValue: '',
                primaryCategoryInputValue: '',
                primaryCategoryNewValue: '',
                showNewPrimaryCategoryField: false,
                secondaryCategoryValue: '',
                secondaryCategoryInputValue: '',
                secondaryCategoryNewValue: '',
                showNewSecondaryCategoryField: false,
                tertiaryCategoryValue: '',
                tertiaryCategoryInputValue: '',
                tertiaryCategoryNewValue: '',
                showNewTertiaryCategoryField: false,
                brandValue: '',
                brandInputValue: '',
                brandNewValue: '',
                showNewBrandField: false
            });
            
            const categoryNames = [];
            if (primaryValue) categoryNames.push('Primary');
            if (secondaryValue) categoryNames.push('Secondary');
            if (tertiaryValue) categoryNames.push('Tertiary');
            if (brandValue) categoryNames.push('Brand');
            
            window.$alertSuccess(`Updated ${categoryNames.join(', ')} for ${selectedPartIds.length} parts successfully`);
        } catch (error) {
            console.error('Error updating parts:', error);
            window.$alertError('Failed to update parts');
            this.setState({ savingCategory: false });
        }
    };

    render() {
        const {classes} = this.props;
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Parts" onSyncDatabase={this.loadData}>
                    <div className="main-dashboard-root">
                        <CircularProgress />
                    </div>
                </DashboardTemplate>
            );
        }

        let lastPartType = '';
        let lastManufacturerFor = '';
        let lastTertiaryType = '';

        // Collect filter options from all parts
        let partTypeOptions = [];
        let manufacturerForOptions = [];
        let tertiaryTypeOptions = [];
        let brandOptions = [];
        
        this.state.parts.filter(x => x.part.isActive).forEach((part) => {
            if (part.part.partType != null && part.part.partType !== '' && !partTypeOptions.includes(part.part.partType))
                partTypeOptions.push(part.part.partType);
            if (part.part.manufacturerFor != null && part.part.manufacturerFor !== '' && !manufacturerForOptions.includes(part.part.manufacturerFor))
                manufacturerForOptions.push(part.part.manufacturerFor);
            if (part.part.tertiaryType != null && part.part.tertiaryType !== '' && !tertiaryTypeOptions.includes(part.part.tertiaryType))
                tertiaryTypeOptions.push(part.part.tertiaryType);
            if (part.part.brand != null && part.part.brand !== '' && !brandOptions.includes(part.part.brand))
                brandOptions.push(part.part.brand);
        });
        
        partTypeOptions = partTypeOptions.sort();
        manufacturerForOptions = manufacturerForOptions.sort();
        tertiaryTypeOptions = tertiaryTypeOptions.sort();
        brandOptions = brandOptions.sort();
        const bulkLeadTimeTargetParts = this.state.bulkLeadTimeTargetParts || [];

        // Filter options based on selections (cascading filters)
        const filteredManufacturerForOptions = this.state.selectedPartType 
            ? manufacturerForOptions.filter(mf => 
                this.state.parts.some(p => 
                    p.part.partType === this.state.selectedPartType && 
                    p.part.manufacturerFor === mf
                )
            )
            : manufacturerForOptions;

        const filteredTertiaryTypeOptions = this.state.selectedManufacturerFor
            ? tertiaryTypeOptions.filter(tt => 
                this.state.parts.some(p => 
                    (!this.state.selectedPartType || p.part.partType === this.state.selectedPartType) &&
                    p.part.manufacturerFor === this.state.selectedManufacturerFor && 
                    p.part.tertiaryType === tt
                )
            )
            : this.state.selectedPartType
            ? tertiaryTypeOptions.filter(tt => 
                this.state.parts.some(p => 
                    p.part.partType === this.state.selectedPartType && 
                    p.part.tertiaryType === tt
                )
            )
            : tertiaryTypeOptions;

        // Apply filters to parts
        let filteredParts = this.state.parts.filter(x => x.part.isActive === true || this.state.showDeactivated);
        
        if (this.state.selectedPartType) {
            filteredParts = filteredParts.filter(x => x.part.partType === this.state.selectedPartType);
        }
        if (this.state.selectedManufacturerFor) {
            filteredParts = filteredParts.filter(x => x.part.manufacturerFor === this.state.selectedManufacturerFor);
        }
        if (this.state.selectedTertiaryType) {
            filteredParts = filteredParts.filter(x => x.part.tertiaryType === this.state.selectedTertiaryType);
        }
        if (this.state.selectedBrand) {
            filteredParts = filteredParts.filter(x => x.part.brand === this.state.selectedBrand);
        }

        // Filter out old revisions if showOldRevs is false
        if (!this.state.showOldRevs) {
            // Group parts by partId and keep only the latest revision for each partId
            const latestRevisionMap = new Map();
            filteredParts.forEach(partExpanded => {
                const partId = partExpanded.part.partId;
                const existing = latestRevisionMap.get(partId);
                if (!existing || partExpanded.part.revision > existing.part.revision) {
                    latestRevisionMap.set(partId, partExpanded);
                }
            });
            filteredParts = Array.from(latestRevisionMap.values());
        }

        // Apply search filter
        if (this.state.searchTerm) {
            const searchTerms = this.state.searchTerm.split(' ').filter(term => term.trim() !== '');
            if (searchTerms.length > 0) {
                filteredParts = filteredParts.filter(part => {
                    return searchTerms.every(term => {
                        const searchTerm = term.toLowerCase();
                        return (
                            (part.part.partId && part.part.partId.toLowerCase().includes(searchTerm)) ||
                            (part.part.description && part.part.description.toLowerCase().includes(searchTerm)) ||
                            (part.part.partType && part.part.partType.toLowerCase().includes(searchTerm)) ||
                            (part.part.manufacturerFor && part.part.manufacturerFor.toLowerCase().includes(searchTerm)) ||
                            (part.part.tertiaryType && part.part.tertiaryType.toLowerCase().includes(searchTerm))
                        );
                    });
                });
            }
        }

        const useFlatSort = !usesCatalogCategoryHeaders(this.state.sortField);
        const displayParts = applyCatalogDisplaySort(filteredParts, this.state.sortField, this.state.sortDirection, {
            kind: 'parts',
            allParts: this.state.parts,
        });

        return (
            <DashboardTemplate title="Parts" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container">
                        <div className={`${classes.toolbar} toolbar-responsive`}>
                            <div className={`${classes.toolbarLeft} toolbar-left`} style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1, maxWidth: '60%' }}>
                                <TextField
                                    value={this.state.searchTerm}
                                    onChange={this.searchPart}
                                    label="Search Parts..."
                                    variant="outlined"
                                    className="search-field"
                                    style={{minWidth: '300px'}}
                                    inputRef={ref => this.searchInputRef = ref}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlPartType"
                                    style={{ minWidth: 200 }}
                                    options={partTypeOptions}
                                    onChange={this.handlePartTypeFilterChange}
                                    value={this.state.selectedPartType}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Part Category (Primary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlManufacturerFor"
                                    style={{ minWidth: 200 }}
                                    options={filteredManufacturerForOptions}
                                    onChange={this.handleManufacturerForFilterChange}
                                    value={this.state.selectedManufacturerFor}
                                    disabled={!this.state.selectedPartType}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Part Category (Secondary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlTertiaryType"
                                    style={{ minWidth: 200 }}
                                    options={filteredTertiaryTypeOptions}
                                    onChange={this.handleTertiaryTypeFilterChange}
                                    value={this.state.selectedTertiaryType}
                                    disabled={!this.state.selectedManufacturerFor}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Part Category (Tertiary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlBrand"
                                    style={{ minWidth: 200 }}
                                    options={brandOptions}
                                    onChange={this.handleBrandFilterChange}
                                    value={this.state.selectedBrand}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Brand" autoComplete="new-password" variant="outlined"/>}
                                />
                            </div>
                            <div className={`${classes.toolbarRight} toolbar-right`}>
                                <div className={`${classes.filterToggle} filter-toggle`} onClick={this.toggleAdvancedInfo}>
                                    <Checkbox
                                        checked={this.state.showAdvancedInfo}
                                        onChange={this.toggleAdvancedInfo}
                                    />
                                    <span className={classes.filterLabel}>Show Statistics</span>
                                </div>
                                <div className={`${classes.filterToggle} filter-toggle`} onClick={this.toggleOldRevs}>
                                    <Checkbox
                                        checked={this.state.showOldRevs}
                                        onChange={this.toggleOldRevs}
                                    />
                                    <span className={classes.filterLabel}>Show Old Revs</span>
                                </div>
                                <div className={`${classes.filterToggle} filter-toggle`} onClick={this.toggleDeactivated}>
                                    <Checkbox
                                        checked={this.state.showDeactivated}
                                        onChange={this.toggleDeactivated}
                                    />
                                    <span className={classes.filterLabel}>Show Deactivated</span>
                                </div>
                                {this.state.permissions.includes('EditAssembliesAndParts') && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.createPart}
                                        className="success-button-lg action-button"
                                        style={{minWidth: 100}}
                                    >
                                        New part
                                    </Button>
                                )}
                            </div>
                        </div>
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[50, 100, 200, 500]}
                                colSpan={4}
                                count={displayParts.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </center>
                        <div className="parts-table-container">
                            <table className="parts-table">
                                <thead>
                                <tr>
                                    <th style={{minWidth: 40}}>Select</th>
                                    <SortableTableHeader field="partNumber" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: window.innerWidth > 2200 ? 350 : 200}}>PN + Description</SortableTableHeader>
                                    <SortableTableHeader field="unitCost" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: 55}}>Unit<br/>Cost</SortableTableHeader>
                                    <SortableTableHeader field="leadTime" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: 50}}>Lead<br/>Time</SortableTableHeader>
                                    <SortableTableHeader field="supersedes" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: 120}}>Supersedes</SortableTableHeader>
                                    <SortableTableHeader field="supersededBy" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: 120}}>Superseded By</SortableTableHeader>
                                    {this.state.showAdvancedInfo ?
                                        <React.Fragment>
                                            <th style={{minWidth: 60, border: '1px solid #fe65ff'}}>
                                                <Tooltip
                                                    title="Total number purchased from summing matching rows in Purchases."
                                                    placement="top" TransitionComponent={Zoom}>
                                                    <span>Total<br/>Received</span>
                                                </Tooltip>
                                            </th>
                                            <th style={{minWidth: 60, border: '1px solid #fe65ff'}}>
                                                <Tooltip
                                                    title="Total number sold in finished goods found by summing matching entries in Child side Total Sales column of Parent/Child relationship."
                                                    placement="top" TransitionComponent={Zoom}>
                                                    <span>Total<br/>Sold</span>
                                                </Tooltip>
                                            </th>
                                            {/*<th style={{minWidth: 60}}>Inv<br/>Corr.</th>*/}
                                            <th style={{minWidth: 60, border: '1px solid #fe65ff'}}>
                                                <Tooltip
                                                    title="Total number currently unpackaged, found by subtracting total packaged from total purchased."
                                                    placement="top" TransitionComponent={Zoom}>
                                                    <span>Total<br/>Unpckgd</span>
                                                </Tooltip>
                                            </th>
                                            <th style={{minWidth: 60, border: '1px solid #fe65ff'}}>
                                                <Tooltip
                                                    title="Total number currently packaged in unsold finished goods and subassemblies. Found by subtracting total sales and total unpackaged from total purchased."
                                                    placement="top" TransitionComponent={Zoom}>
                                                    <span>Total in<br/>FG/SubA</span>
                                                </Tooltip>
                                            </th>
                                            <th style={{minWidth: 60, border: '1px solid #fe65ff'}}>
                                                <Tooltip
                                                    title="Total number packaged into assemblies found by summing matching entries in Child side Total Sales column of Parent/Child relationship."
                                                    placement="top" TransitionComponent={Zoom}>
                                                    <span>Total<br/>Pckgd</span>
                                                </Tooltip>
                                            </th>
                                            <th style={{minWidth: 60, border: '1px solid #fe65ff'}}>
                                                <Tooltip
                                                    title="Total number sold on their own without being part of an assembly. Equal to sum of all entries matching the part number on the Sales Log."
                                                    placement="top" TransitionComponent={Zoom}>
                                                    <span>Total Sold<br/>Unpckgd</span>
                                                </Tooltip>
                                            </th>
                                            <th style={{minWidth: 80}}>4 week<br/>Sales / wk</th>
                                            <th style={{minWidth: 80}}>24 week<br/>Sales / wk</th>
                                            <th style={{minWidth: 70}}>Avg<br/>Sales / wk</th>
                                        </React.Fragment>
                                        : ""}
                                    {!this.state.showAdvancedInfo ?
                                        <React.Fragment>
                                            <th style={{minWidth: 50}}>Cost<br/>Type</th>
                                            <th style={{minWidth: 100}}>Tiered Pricing</th>
                                            <th style={{minWidth: 75}}>Cost</th>
                                            <th style={{minWidth: 50}}>Qty</th>
                                        </React.Fragment>
                                        : ""}
                                </tr>
                                </thead>
                                <tbody>
                                {displayParts.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((partExpanded) => {
                                    const part = partExpanded.part;
                                    if (!part) return '';

                                    let partTieredCostFormulas = part.vendorParts.length > 0 ? part.vendorParts[0].tieredCostFormulas : [];
                                    let selectedVendor = part.vendorParts.length > 0 ? part.vendorParts[0] : null;
                                    if (part.selectedVendorId !== null) {
                                        selectedVendor = part.vendorParts.find(x => x.vendorId === part.selectedVendorId);
                                        partTieredCostFormulas = selectedVendor ? selectedVendor.tieredCostFormulas : [];
                                    }

                                    // Get the selected formula or first formula for display
                                    const selectedFormula = partTieredCostFormulas.find(f => f.isSelected) || partTieredCostFormulas[0];
                                    
                                    // Get cost type from selected vendor part, default to part.costType if no vendor selected
                                    const vendorCostType = selectedVendor ? (selectedVendor.costType ?? 0) : (part.costType ?? 0);

                                    let partTypeHeader = [];
                                    if (!useFlatSort && part.partType !== lastPartType) {
                                        const currentPartType = part.partType;
                                        lastPartType = part.partType;
                                        partTypeHeader.push(<tr className="part-type-header">
                                            <td colSpan={this.state.showAdvancedInfo ? 36 : 27} style={{
                                                backgroundColor: '#f5f5f5',
                                                fontWeight: 'bold',
                                                padding: '8px',
                                                borderBottom: '1px solid #ddd',
                                                cursor: this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts') ? 'pointer' : 'default'
                                            }} 
                                            className='text-left'
                                            onClick={() => this.handlePartTypeHeaderClick(currentPartType)}
                                            title={this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts') ? 'Click to edit part category (primary)' : ''}
                                            >{currentPartType}</td>
                                        </tr>);
                                    }

                                    let manufacturerForHeader = [];
                                    if (!useFlatSort && part.manufacturerFor !== lastManufacturerFor) {
                                        const currentManufacturerFor = part.manufacturerFor;
                                        lastManufacturerFor = part.manufacturerFor;
                                        manufacturerForHeader.push(<tr className="manufacturer-header">
                                            <td colSpan={this.state.showAdvancedInfo ? 36 : 27} style={{
                                                backgroundColor: '#e8e8e8',
                                                fontWeight: 'bold',
                                                padding: '8px',
                                                borderBottom: '1px solid #ddd',
                                                cursor: this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts') ? 'pointer' : 'default'
                                            }} 
                                            className='text-left'
                                            onClick={() => this.handleManufacturerForHeaderClick(currentManufacturerFor)}
                                            title={this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts') ? 'Click to edit part category (secondary)' : ''}
                                            >{currentManufacturerFor}</td>
                                        </tr>);
                                    }

                                    let tertiaryTypeHeader = [];
                                    if (!useFlatSort && part.tertiaryType !== lastTertiaryType) {
                                        const currentTertiaryType = part.tertiaryType;
                                        // Show header if there's actually a tertiary type
                                        if (part.tertiaryType && part.tertiaryType.trim() !== '') {
                                            tertiaryTypeHeader.push(
                                                <tr className="tertiary-type-header">
                                                    <td className='text-left' colSpan={this.state.showAdvancedInfo ? 36 : 27} style={{ 
                                                        backgroundColor: '#767676', 
                                                        fontWeight: 'bold', 
                                                        padding: '2px 4px', 
                                                        borderBottom: '1px solid #ccc',
                                                        cursor: this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts') ? 'pointer' : 'default'
                                                    }}
                                                    onClick={() => this.handleTertiaryTypeHeaderClick(currentTertiaryType)}
                                                    title={this.state.permissions && this.state.permissions.includes('EditAssembliesAndParts') ? 'Click to edit part category (tertiary)' : ''}
                                                    >
                                                        {currentTertiaryType}
                                                    </td>
                                                </tr>
                                            );
                                        } else if (lastTertiaryType && lastTertiaryType.trim() !== '') {
                                            // Add an empty/clearing header when transitioning from tertiary type back to no tertiary type
                                            tertiaryTypeHeader.push(
                                                <tr className="tertiary-type-header">
                                                    <td className='text-left' colSpan={this.state.showAdvancedInfo ? 36 : 27} style={{ backgroundColor: 'transparent', height: '1px', padding: '0', borderBottom: 'none' }}>
                                                        &nbsp;
                                                    </td>
                                                </tr>
                                            );
                                        }
                                        lastTertiaryType = part.tertiaryType;
                                    }

                                    return (
                                        <React.Fragment>
                                            {partTypeHeader}
                                            {manufacturerForHeader}
                                            {tertiaryTypeHeader}
                                            <tr style={this.state.permissions.includes('EditAssembliesAndParts') ? {
                                                 cursor: 'pointer',
                                                 opacity: (part.isActive && part.isInventoryItem) ? 1 : 0.6
                                             } : {}}
                                                onClick={(event) => this.handleRowClick(event, partExpanded)}>
                                                <td 
                                                    style={{textAlign: 'center', paddingTop: 4, cursor: 'pointer'}}
                                                    onClick={(e) => {
                                                        const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                        const isShiftPressed = e.shiftKey;
                                                        
                                                        if (isCtrlPressed || isShiftPressed) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                e.nativeEvent.stopImmediatePropagation();
                                                            }
                                                            const syntheticEvent = {
                                                                ctrlKey: isCtrlPressed,
                                                                metaKey: e.metaKey,
                                                                shiftKey: isShiftPressed,
                                                                preventDefault: () => {},
                                                                stopPropagation: () => {},
                                                                target: { checked: !this.state.selectedParts[part.id] },
                                                                nativeEvent: e.nativeEvent
                                                            };
                                                            this.handlePartSelection(part.id, syntheticEvent);
                                                        }
                                                    }}
                                                    onMouseDown={(e) => {
                                                        const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                        const isShiftPressed = e.shiftKey;
                                                        
                                                        if (isCtrlPressed || isShiftPressed) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                e.nativeEvent.stopImmediatePropagation();
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <span
                                                        onClick={(e) => {
                                                            const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                            const isShiftPressed = e.shiftKey;
                                                            
                                                            if (isCtrlPressed || isShiftPressed) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                    e.nativeEvent.stopImmediatePropagation();
                                                                }
                                                            }
                                                        }}
                                                        style={{display: 'inline-block'}}
                                                    >
                                                        <Checkbox
                                                            checked={!!this.state.selectedParts[part.id]}
                                                            onChange={(event) => {
                                                                if (this.state.isProcessingModifierClick) {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();
                                                                    return;
                                                                }
                                                                
                                                                const isCtrlPressed = event.ctrlKey || event.metaKey;
                                                                const isShiftPressed = event.shiftKey;
                                                                
                                                                if (isCtrlPressed || isShiftPressed) {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();
                                                                    return;
                                                                }
                                                                
                                                                event.stopPropagation();
                                                                this.handlePartSelection(part.id, event);
                                                            }}
                                                            onClick={(e) => {
                                                                const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                                const isShiftPressed = e.shiftKey;
                                                                
                                                                if (isCtrlPressed || isShiftPressed) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                        e.nativeEvent.stopImmediatePropagation();
                                                                    }
                                                                    return false;
                                                                }
                                                            }}
                                                            style={{padding: '0 0 2px'}}
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" onClick={(event) => this.state.permissions.includes('EditAssembliesAndParts') ? this.editPart(partExpanded, event.ctrlKey) : null}>
                                                    <PartDisplay 
                                                        part={{
                                                            partId: part.partId,
                                                            revision: part.revision,
                                                            description: part.description
                                                        }}
                                                        variant="table"
                                                        classes={this.props.classes}
                                                        onClick={this.state.permissions.includes('EditAssembliesAndParts') ? 
                                                            (event) => this.editPart(partExpanded, event.ctrlKey) : null
                                                        }
                                                    />
                                                </td>
                                                <td>{(partExpanded.cost / partExpanded.quantity).toFixed(2) !== 'NaN' ? '$' + (partExpanded.cost / partExpanded.quantity).toFixed(2) : ''}</td>
                                                <td>{part.leadTimeInWeeks}</td>
                                                {part.supersedesId ?
                                                    <td className="text-left">
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                            <span style={{
                                                                fontWeight: 'bold',
                                                                color: 'black',
                                                                cursor: 'pointer'
                                                            }}
                                                                  onClick={() => globalProps.history.push(`/admin/parts/${this.state.parts.find(x => x.part.id === part.supersedesId).part.id}`)}>
                                                                    {this.state.parts.find(x => x.part.id === part.supersedesId).part.partId} rev {this.state.parts.find(x => x.part.id === part.supersedesId).part.revision}
                                                                </span>
                                                            :
                                                            <span>{this.state.parts.find(x => x.part.id === part.supersedesId).part.partId} rev {this.state.parts.find(x => x.part.id === part.supersedesId).part.revision}</span>
                                                        }
                                                    </td>
                                                    : <td></td>}
                                                {part.supersededById ?
                                                    <td className="text-left">
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ?
                                                            <span style={{
                                                                fontWeight: 'bold',
                                                                color: 'black',
                                                                cursor: 'pointer'
                                                            }}
                                                                  onClick={() => globalProps.history.push(`/admin/parts/${this.state.parts.find(x => x.part.id === part.supersededById).part.id}`)}>
                                                                    {this.state.parts.find(x => x.part.id === part.supersededById).part.partId} rev {this.state.parts.find(x => x.part.id === part.supersededById).part.revision}
                                                                </span>
                                                            :
                                                            <span>{this.state.parts.find(x => x.part.id === part.supersededById).part.partId} rev {this.state.parts.find(x => x.part.id === part.supersededById).part.revision}</span>
                                                        }
                                                    </td>
                                                    : <td></td>}
                                                {!this.state.showAdvancedInfo ?
                                                    <React.Fragment>
                                                        <td>{vendorCostType === 0 ? 'Tiered' : 'Fixed'}</td>
                                                        <td>
                                                            {vendorCostType === 0 && selectedFormula ? (
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                                    <Tooltip
                                                                        title={
                                                                            <div style={{ whiteSpace: 'pre-line' }}>
                                                                                {this.getTieredPricingTooltip(partTieredCostFormulas)}
                                                                            </div>
                                                                        }
                                                                        placement="top"
                                                                        TransitionComponent={Zoom}
                                                                    >
                                                                        <span style={{ cursor: 'help' }}>
                                                                            {selectedFormula.quantity}: ${Number.parseFloat(selectedFormula.price).toFixed(2)}
                                                                            <FontAwesomeIcon 
                                                                                icon={faInfoCircle} 
                                                                                style={{ fontSize: '14px', color: '#666', marginLeft: '4px' }}
                                                                            />
                                                                        </span>
                                                                    </Tooltip>
                                                                </div>
                                                            ) : ''}
                                                        </td>
                                                        <td>${partExpanded.cost.toFixed(2)}</td>
                                                        <td>{partExpanded.quantity}</td>
                                                    </React.Fragment>
                                                    : ""}
                                                {this.state.showAdvancedInfo ?
                                                    <React.Fragment>
                                                        <td>{partExpanded.totalReceived}</td>
                                                        <td>{partExpanded.totalSold}</td>
                                                        {/*<td>{part.inventoryCorrection}</td>*/}
                                                        <td>{partExpanded.totalUnpackaged}</td>
                                                        <td>{partExpanded.totalInFG}</td>
                                                        <td>{partExpanded.totalPackaged}</td>
                                                        <td>{partExpanded.totalSoldUnpackaged}</td>
                                                        <td>{(partExpanded.supersedesFourWeekAvgSales > 0 ? partExpanded.fourWeekAvgSales + partExpanded.supersedesFourWeekAvgSales : partExpanded.fourWeekAvgSales).toFixed(2)}</td>
                                                        <td>{(partExpanded.supersedesTwentyFourWeekAvgSales > 0 ? partExpanded.twentyFourWeekAvgSales + partExpanded.supersedesTwentyFourWeekAvgSales : partExpanded.twentyFourWeekAvgSales).toFixed(2)}</td>
                                                        <td>{(partExpanded.supersedesFourWeekAvgSales > 0 || partExpanded.supersedesTwentyFourWeekAvgSales > 0 ? 
                                                            ((partExpanded.fourWeekAvgSales + (partExpanded.supersedesFourWeekAvgSales > 0 ? partExpanded.supersedesFourWeekAvgSales : 0)) + 
                                                             (partExpanded.twentyFourWeekAvgSales + (partExpanded.supersedesTwentyFourWeekAvgSales > 0 ? partExpanded.supersedesTwentyFourWeekAvgSales : 0))) / 2 : 
                                                            partExpanded.averageSalesPerWeek).toFixed(2)}</td>
                                                    </React.Fragment>
                                                    : ""}
                                            </tr>
                                        </React.Fragment>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[50, 100, 200, 500]}
                                colSpan={4}
                                count={displayParts.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </center>
                        
                        {/* Floating action buttons for multiselect */}
                        {Object.keys(this.state.selectedParts).length > 0 && (
                            <div style={{
                                position: 'fixed',
                                bottom: 20,
                                left: 182,
                                right: 0,
                                zIndex: 1000,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '16px',
                                pointerEvents: 'none'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    gap: '16px',
                                    pointerEvents: 'auto'
                                }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.deselectAllParts}
                                    className="success-button-lg"
                                >
                                    Deselect All
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.openAssignCategory}
                                    className="success-button-lg"
                                >
                                    Assign Categories
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.setState({assignVehiclesOpen: true})}
                                    className="success-button-lg"
                                >
                                    Assign Vehicles
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.openBulkLeadTimeForSelected}
                                    className="success-button-lg"
                                >
                                    Update Lead Time
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.makeNonInventoryItems}
                                    className="success-button-lg"
                                >
                                    {(() => {
                                        const selectedPartIds = Object.keys(this.state.selectedParts);
                                        if (selectedPartIds.length === 0) return 'Toggle Inventory Status';
                                        
                                        const selectedParts = selectedPartIds.map(partId => 
                                            this.state.parts.find(p => p.part.id === partId)
                                        ).filter(Boolean);
                                        
                                        const allNonInventory = selectedParts.every(part => !part.part.isInventoryItem);
                                        return allNonInventory ? 'Make Inventory Items' : 'Make Non-Inventory Items';
                                    })()}
                                </Button>
                                </div>
                            </div>
                        )}

                        <DrawerMenuRight
                            title="Bulk Lead Time for Selected Parts"
                            customWidth={900}
                            open={this.state.bulkLeadTimeDrawerOpen}
                            onClose={this.closeBulkLeadTimeDrawer}
                            disableEnterKeySubmit
                            hasUnsavedChanges={
                                this.state.bulkLeadTimeWeeks !== '' ||
                                this.state.bulkLeadTimeConfirmText !== '' ||
                                this.state.bulkLeadTimeTargetParts.length > 0
                            }
                        >
                            <div style={{ padding: '20px' }}>
                                <TextField
                                    value={this.state.bulkLeadTimeWeeks}
                                    onChange={(e) => this.setState({ bulkLeadTimeWeeks: e.target.value })}
                                    label="New Lead Time (weeks)"
                                    variant="outlined"
                                    type="number"
                                    inputProps={{ min: 1, max: 52, step: 1 }}
                                    style={{ width: '100%', marginBottom: 20 }}
                                />

                                <Typography variant="subtitle1" style={{ marginBottom: 10, fontWeight: 600 }}>
                                    Confirm the following list of parts will be updated ({bulkLeadTimeTargetParts.length})
                                </Typography>
                                <div className="parts-table-container" style={{ maxHeight: 600, overflowY: 'auto', marginBottom: 20 }}>
                                    <table className="parts-table">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: 180 }}>Part</th>
                                                <th style={{ minWidth: 320 }}>Description</th>
                                                <th style={{ minWidth: 180 }}>Vendor</th>
                                                <th style={{ minWidth: 80 }}>Current</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bulkLeadTimeTargetParts.length === 0 ? (
                                                <tr>
                                                    <td colSpan={4}>No parts selected.</td>
                                                </tr>
                                            ) : bulkLeadTimeTargetParts.map((partExpanded) => (
                                                <tr key={partExpanded.part.id}>
                                                    <td>{partExpanded.part.partId} rev {partExpanded.part.revision}</td>
                                                    <td className="text-left">{partExpanded.part.description}</td>
                                                    <td>{this.getVendorNameById(partExpanded.part.selectedVendorId) || '-'}</td>
                                                    <td>{partExpanded.part.leadTimeInWeeks}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <TextField
                                    value={this.state.bulkLeadTimeConfirmText}
                                    onChange={(e) => this.setState({ bulkLeadTimeConfirmText: e.target.value })}
                                    label='Type "UPDATE" to confirm'
                                    variant="outlined"
                                    style={{ width: '100%', marginBottom: 20 }}
                                />

                                {this.state.savingBulkLeadTime ? (
                                    <CircularProgress />
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.applyBulkLeadTimeUpdate}
                                        className="success-button-lg"
                                        disabled={bulkLeadTimeTargetParts.length === 0}
                                    >
                                        Apply Lead Time Update
                                    </Button>
                                )}
                            </div>
                        </DrawerMenuRight>

                        {/* Category assignment drawer */}
                        <DrawerMenuRight 
                            title="Assign Categories"
                            customWidth={600} 
                            open={this.state.assignCategoryOpen}
                            onClose={this.closeAssignCategory}
                            disableEnterKeySubmit
                            hasUnsavedChanges={
                                this.state.primaryCategoryValue !== '' || 
                                this.state.secondaryCategoryValue !== '' || 
                                this.state.tertiaryCategoryValue !== '' ||
                                this.state.brandValue !== '' ||
                                this.state.primaryCategoryNewValue !== '' ||
                                this.state.secondaryCategoryNewValue !== '' ||
                                this.state.tertiaryCategoryNewValue !== '' ||
                                this.state.brandNewValue !== ''
                            }
                        >
                            <div style={{padding: '20px'}}>
                                {/* Primary Category */}
                                <Autocomplete autoHighlight
                                    style={{marginBottom: 20}}
                                    options={this.getCategoryOptions('primary')}
                                    onChange={(event, newValue) => {
                                        if (newValue === 'New...') {
                                            this.setState({
                                                primaryCategoryValue: 'New...',
                                                primaryCategoryInputValue: 'New...',
                                                showNewPrimaryCategoryField: true,
                                                primaryCategoryNewValue: ''
                                            });
                                        } else {
                                            this.setState({
                                                primaryCategoryValue: newValue || '',
                                                primaryCategoryInputValue: newValue || '',
                                                showNewPrimaryCategoryField: false,
                                                primaryCategoryNewValue: ''
                                            });
                                        }
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        this.setState({
                                            primaryCategoryInputValue: newInputValue
                                        });
                                    }}
                                    value={this.state.primaryCategoryValue}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Part Category (Primary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                {this.state.showNewPrimaryCategoryField && (
                                    <TextField
                                        value={this.state.primaryCategoryNewValue}
                                        onChange={(e) => this.setState({primaryCategoryNewValue: e.target.value})}
                                        label="New Part Category (Primary)"
                                        variant="outlined"
                                        style={{width: '100%', marginBottom: 20}}
                                        inputProps={{maxLength: 200}}
                                    />
                                )}

                                {/* Secondary Category */}
                                <Autocomplete autoHighlight
                                    style={{marginBottom: 20}}
                                    options={this.getCategoryOptions('secondary')}
                                    onChange={(event, newValue) => {
                                        if (newValue === 'New...') {
                                            this.setState({
                                                secondaryCategoryValue: 'New...',
                                                secondaryCategoryInputValue: 'New...',
                                                showNewSecondaryCategoryField: true,
                                                secondaryCategoryNewValue: ''
                                            });
                                        } else {
                                            this.setState({
                                                secondaryCategoryValue: newValue || '',
                                                secondaryCategoryInputValue: newValue || '',
                                                showNewSecondaryCategoryField: false,
                                                secondaryCategoryNewValue: ''
                                            });
                                        }
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        this.setState({
                                            secondaryCategoryInputValue: newInputValue
                                        });
                                    }}
                                    value={this.state.secondaryCategoryValue}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Part Category (Secondary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                {this.state.showNewSecondaryCategoryField && (
                                    <TextField
                                        value={this.state.secondaryCategoryNewValue}
                                        onChange={(e) => this.setState({secondaryCategoryNewValue: e.target.value})}
                                        label="New Part Category (Secondary)"
                                        variant="outlined"
                                        style={{width: '100%', marginBottom: 20}}
                                        inputProps={{maxLength: 200}}
                                    />
                                )}

                                {/* Tertiary Category */}
                                <Autocomplete autoHighlight
                                    style={{marginBottom: 20}}
                                    options={this.getCategoryOptions('tertiary')}
                                    onChange={(event, newValue) => {
                                        if (newValue === 'New...') {
                                            this.setState({
                                                tertiaryCategoryValue: 'New...',
                                                tertiaryCategoryInputValue: 'New...',
                                                showNewTertiaryCategoryField: true,
                                                tertiaryCategoryNewValue: ''
                                            });
                                        } else {
                                            this.setState({
                                                tertiaryCategoryValue: newValue || '',
                                                tertiaryCategoryInputValue: newValue || '',
                                                showNewTertiaryCategoryField: false,
                                                tertiaryCategoryNewValue: ''
                                            });
                                        }
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        this.setState({
                                            tertiaryCategoryInputValue: newInputValue
                                        });
                                    }}
                                    value={this.state.tertiaryCategoryValue}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Part Category (Tertiary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                {this.state.showNewTertiaryCategoryField && (
                                    <TextField
                                        value={this.state.tertiaryCategoryNewValue}
                                        onChange={(e) => this.setState({tertiaryCategoryNewValue: e.target.value})}
                                        label="New Part Category (Tertiary)"
                                        variant="outlined"
                                        style={{width: '100%', marginBottom: 20}}
                                        inputProps={{maxLength: 200}}
                                    />
                                )}

                                {/* Brand */}
                                <Autocomplete autoHighlight
                                    style={{marginBottom: 20}}
                                    options={this.getCategoryOptions('brand')}
                                    onChange={(event, newValue) => {
                                        if (newValue === 'New...') {
                                            this.setState({
                                                brandValue: 'New...',
                                                brandInputValue: 'New...',
                                                showNewBrandField: true,
                                                brandNewValue: ''
                                            });
                                        } else {
                                            this.setState({
                                                brandValue: newValue || '',
                                                brandInputValue: newValue || '',
                                                showNewBrandField: false,
                                                brandNewValue: ''
                                            });
                                        }
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        this.setState({
                                            brandInputValue: newInputValue
                                        });
                                    }}
                                    value={this.state.brandValue}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Brand" autoComplete="new-password" variant="outlined"/>}
                                />
                                {this.state.showNewBrandField && (
                                    <TextField
                                        value={this.state.brandNewValue}
                                        onChange={(e) => this.setState({brandNewValue: e.target.value})}
                                        label="New Brand"
                                        variant="outlined"
                                        style={{width: '100%', marginBottom: 20}}
                                        inputProps={{maxLength: 200}}
                                    />
                                )}

                                <div style={{marginBottom: 20}}>
                                    Selected parts: {Object.keys(this.state.selectedParts).length}
                                </div>
                                <div style={{marginBottom: 20, fontSize: '14px', color: '#666'}}>
                                    Leave categories empty to keep existing values. Only specified categories will be updated.
                                </div>
                                {this.state.savingCategory ? (
                                    <CircularProgress />
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.saveAssignCategory}
                                        className="success-button-lg"
                                    >
                                        Update Selected Parts
                                    </Button>
                                )}
                            </div>
                        </DrawerMenuRight>

                        <BulkAssignVehiclesDrawer
                            open={this.state.assignVehiclesOpen}
                            onClose={() => this.setState({assignVehiclesOpen: false})}
                            products={Object.keys(this.state.selectedParts).map(id => ({productType: 'Part', productId: id}))}
                        />

                        {/* Category editing drawers */}
                        {this.state.editPartTypeOpen && (
                            <DrawerMenuRight title="Edit Part Category (Primary)" customWidth={400} open={this.state.editPartTypeOpen}
                                           onClose={() => this.setState({editPartTypeOpen: false, newPartTypeValue: '', oldValue: ''})}
                                           hasUnsavedChanges={this.state.newPartTypeValue !== ''}
                                           onSubmit={this.savePartType}
                                           submitConfirmMessage="Are you sure you want to save this part category (primary)?"
                                           >
                                <TextField
                                    key={this.state.oldValue} // Force re-render when value changes
                                    defaultValue={this.state.newPartTypeValue}
                                    onChange={(e) => this.setState({newPartTypeValue: e.target.value})}
                                    label="Part Category (Primary)"
                                    variant="outlined"
                                    autoComplete="off"
                                    style={{width: '100%', marginBottom: 20}}
                                />
                                {this.state.savingCategory ? (
                                    <CircularProgress />
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.savePartType}
                                        className="success-button-lg"
                                    >
                                        Save
                                    </Button>
                                )}
                            </DrawerMenuRight>
                        )}
                        
                        {this.state.editManufacturerForOpen && (
                            <DrawerMenuRight title="Edit Part Category (Secondary)" customWidth={400} open={this.state.editManufacturerForOpen}
                                           onClose={() => this.setState({editManufacturerForOpen: false, newManufacturerForValue: '', oldValue: ''})}
                                           hasUnsavedChanges={this.state.newManufacturerForValue !== ''}
                                           onSubmit={this.saveManufacturerFor}
                                           submitConfirmMessage="Are you sure you want to save this part category (secondary)?"
                                           >
                                <TextField
                                    key={this.state.oldValue} // Force re-render when value changes
                                    defaultValue={this.state.newManufacturerForValue}
                                    onChange={(e) => this.setState({newManufacturerForValue: e.target.value})}
                                    label="Part Category (Secondary)"
                                    variant="outlined"
                                    style={{width: '100%', marginBottom: 20}}
                                    autoComplete="off"
                                />
                                {this.state.savingCategory ? (
                                    <CircularProgress />
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.saveManufacturerFor}
                                        className="success-button-lg"
                                    >
                                        Save
                                    </Button>
                                )}
                            </DrawerMenuRight>
                        )}
                        
                        {this.state.editTertiaryTypeOpen && (
                            <DrawerMenuRight title="Edit Part Category (Tertiary)" customWidth={400} open={this.state.editTertiaryTypeOpen}
                                           onClose={() => this.setState({editTertiaryTypeOpen: false, newTertiaryTypeValue: '', oldValue: ''})}
                                           hasUnsavedChanges={this.state.newTertiaryTypeValue !== ''}
                                           onSubmit={this.saveTertiaryType}
                                           submitConfirmMessage="Are you sure you want to save this part category (tertiary)?"
                                           >
                                <TextField
                                    key={this.state.oldValue} // Force re-render when value changes
                                    defaultValue={this.state.newTertiaryTypeValue}
                                    onChange={(e) => this.setState({newTertiaryTypeValue: e.target.value})}
                                    label="Part Category (Tertiary)"
                                    variant="outlined"
                                    autoComplete="off"
                                    style={{width: '100%', marginBottom: 20}}
                                />
                                {this.state.savingCategory ? (
                                    <CircularProgress />
                                ) : (
                                    <Button
                                        onClick={this.saveTertiaryType}
                                        primary={true}
                                        className="success-button-lg"
                                    >Save</Button>
                                )}
                            </DrawerMenuRight>
                        )}

                        {this.state.editPartOpen ?
                        <DrawerMenuRight title={"New Part"} customWidth={600} open={this.state.editPartOpen}
                                         onClose={this.handleCloseEditPart}
                                         hasUnsavedChanges={this.hasEditPartUnsavedChanges()}
                                         onSubmit={this.savePart}
                                         submitConfirmMessage="Are you sure you want to save this part?"
                                         >
                            <center>
                                {/* Part Number and Description on same line */}
                                <TextField defaultValue={this.state.editingPart.part.partId}
                                        onChange={this.changePartId} label={"Part Number"} variant="outlined"
                                        style={{width: '27%', margin: '0 5px 20px 0'}} inputProps={{maxLength: 50}}
                                        autoComplete="off"/>
                                <TextField defaultValue={this.state.editingPart.part.description}
                                        onChange={this.changeDescription} label={"Description"}
                                        variant="outlined" style={{width: '67%', margin: '0 0 20px 5px'}}
                                        inputProps={{maxLength: 500}} autoComplete="off"/>
                                
                                {/* Revision and Revision Notes on same line */}
                                <TextField defaultValue={this.state.editingPart.part.revision}
                                        onChange={this.changeRevision} label={"Revision"} variant="outlined"
                                        style={{width: '27%', margin: '0 5px 20px 0'}} inputProps={{maxLength: 5}}
                                        autoComplete="off"/>
                                <TextField defaultValue={this.state.editingPart.part.revisionNotes}
                                        onChange={this.changeRevisionNotes} label={"Revision Notes"}
                                        variant="outlined" style={{width: '67%', margin: '0 0 20px 5px'}}
                                        inputProps={{maxLength: 500}} autoComplete="off"/>
                                
                                {/* MSRP, Lead Time, and Inventory Strategy on same line */}
                                <TextField value={this.state.editingPart.part.msrp || ''}
                                        onChange={(event) => this.setState({editingPart: {...this.state.editingPart, part: {...this.state.editingPart.part, msrp: event.target.value}}})} label={"MSRP"} variant="outlined"
                                        style={{width: '23%', margin: '0 5px 20px 0'}}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>
                                        }} autoComplete="off"/>
                                <TextField value={this.state.editingPart.part.leadTimeInWeeks || ''}
                                        onChange={(event) => this.setState({editingPart: {...this.state.editingPart, part: {...this.state.editingPart.part, leadTimeInWeeks: event.target.value}}})} label={"Lead Time (weeks)"}
                                        variant="outlined" style={{width: '23%', margin: '0 5px 20px 5px'}}
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                            onInput: parseNumberInputValue
                                        }} autoComplete="off"/>
                                <FormControl style={{width: '23%', margin: '0 0 20px 5px'}} variant="outlined">
                                    <InputLabel id="cost-type-select-label">Inventory Strategy</InputLabel>
                                    <Select
                                        value={this.state.editingPart.part.inventoryStrategy ?? 'A'}
                                        style={{width: '100%'}}
                                        label="Inventory Strategy"
                                    >
                                        <MenuItem value={'A'}
                                                onClick={() => this.handleInventoryStrategyChange('A')}>A</MenuItem>
                                        <MenuItem value={'B'}
                                                onClick={() => this.handleInventoryStrategyChange('B')}>B</MenuItem>
                                    </Select>
                                </FormControl>
                                
                                <div style={{marginBottom: 20, fontWeight: 600}}>Note: part pricing to be filled out on the next page.</div>
                                {this.state.savingPart === true ?
                                    <CircularProgress/>
                                    :
                                    <Button 
                                        variant="contained"
                                        color="primary"
                                        onClick={this.savePart}
                                        className="success-button-lg"
                                    >
                                        Save
                                    </Button>
                                }
                            </center>
                        </DrawerMenuRight>
                        : ""}
                    </div>
                </div>
            </DashboardTemplate>
        );
    }
}

let globalProps;

AdminParts.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminParts);
